import type { BranchInput, DepartmentInput, DesignationInput, EmployeeCreateInput, EmployeeSensitiveInput, EmployeeUpdateInput, HeartbeatInput, WorkSessionSummary } from '@stoplord/shared';
import { api } from '@/lib/api';
import type { AttendanceReport, Employee, EmployeeDetail, LiveSession, OrgStructure, WorkSessionRow } from './types';

type Q = Record<string, string | number | undefined>;

export const employeesApi = {
  list: (q: Q) => api.page<Employee>('/hrm/employees', q),
  get: (id: string) => api.get<EmployeeDetail>(`/hrm/employees/${id}`),
  me: () => api.get<EmployeeDetail | null>('/hrm/employees/me'),
  create: (body: EmployeeCreateInput) => api.post<Employee>('/hrm/employees', body),
  update: (id: string, body: EmployeeUpdateInput) => api.patch<Employee>(`/hrm/employees/${id}`, body),
  archive: (id: string) => api.delete(`/hrm/employees/${id}`),
  setSensitive: (id: string, body: EmployeeSensitiveInput) => api.put(`/hrm/employees/${id}/sensitive`, body),
  reveal: (id: string) => api.post<Record<string, string | null>>(`/hrm/employees/${id}/sensitive/reveal`),
};

export const orgApi = {
  get: () => api.get<OrgStructure>('/hrm/org'),
  createBranch: (b: BranchInput) => api.post('/hrm/org/branches', b),
  updateBranch: (id: string, b: Partial<BranchInput>) => api.patch(`/hrm/org/branches/${id}`, b),
  deleteBranch: (id: string) => api.delete(`/hrm/org/branches/${id}`),
  createDepartment: (b: DepartmentInput) => api.post('/hrm/org/departments', b),
  updateDepartment: (id: string, b: Partial<DepartmentInput>) => api.patch(`/hrm/org/departments/${id}`, b),
  deleteDepartment: (id: string) => api.delete(`/hrm/org/departments/${id}`),
  createDesignation: (b: DesignationInput) => api.post('/hrm/org/designations', b),
  updateDesignation: (id: string, b: Partial<DesignationInput>) => api.patch(`/hrm/org/designations/${id}`, b),
  deleteDesignation: (id: string) => api.delete(`/hrm/org/designations/${id}`),
};

export const workApi = {
  heartbeat: (b: HeartbeatInput) => api.post<{ session: WorkSessionSummary | null; idleForMs: number }>('/hrm/work-sessions/heartbeat', b),
  current: () => api.get<WorkSessionSummary | null>('/hrm/work-sessions/current'),
  startBreak: (reason?: string) => api.post<WorkSessionSummary>('/hrm/work-sessions/break/start', { reason }),
  endBreak: () => api.post<WorkSessionSummary>('/hrm/work-sessions/break/end'),
  list: (q: Q) => api.page<WorkSessionRow>('/hrm/work-sessions', q),
  live: () => api.get<{ counts: { active: number; idle: number; onBreak: number }; items: LiveSession[] }>('/hrm/work-sessions/live'),
  attendance: (q: Q) => api.get<AttendanceReport>('/hrm/work-sessions/attendance', q),
  forceEnd: (id: string) => api.post(`/hrm/work-sessions/${id}/end`),
};
